<template>
    <vue-timepicker
        class="apprentice-default-time-picker"
        :disabled="disabled"
        :placeholder="placeholder ?? $t('common.input.choose_time')"
        :value="value"
        :manual-input="true"
        :format="format"
        :hide-clear-button="hideClearButton"
        @change="updateValue($event)"
        @blur="blur($event)">
    </vue-timepicker>
</template>

<script>
    import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';

    export default {
        components: { VueTimepicker },
        name: 'design-2021-apprentice-timepicker-component',
        props: {
            placeholder: {
            type: String | null,
            },
            value: {
                type: String | Object,
            },
            format: {
                type: String,
                default: 'HH:mm',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            hideClearButton: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            updateValue(object) {
                this.$emit('change', object);

                for (const key of this.format.split(':')) {
                    if (!object.data[key] || isNaN(object.data[key])) {
                        this.$emit('input', null);
                        return;
                    }
                }

                const seconds = object.data.ss ? object.data.ss : '00';
                this.$emit('input', object.data.HH + ':' + object.data.mm + ':' + seconds);
            },
            blur(event) {
                this.$emit('blur', event);
            },
        },
    };
</script>

<style scoped lang="scss">
    .apprentice-default-time-picker ::v-deep {
        width: 100%;

        input {
            padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
            border-radius: $border-radius-content;
            height: auto;
            border: none;
            font-size: $default-font-size;
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
            width: 100%;

            &,
            &:focus {
                background-color: $secondary-background-color;
            }

            &:focus-visible {
                outline: none;
                box-shadow: 0 0 0 0.2rem darken($secondary-background-color, 25%);
            }
        }

        .controls {
            height: 52px;
            right: 7px;

            .char {
                font-size: 1.3125rem;
                font-weight: $font-weight-bold;
                color: var(--primary);
                opacity: 0.5;

                &:hover {
                    opacity: 1;
                }
            }
        }

        .dropdown {
            top: 52px;
            border-radius: $border-radius-content;

            .hours,
            .minutes {
                .hint {
                    color: var(--primary);
                    font-weight: $font-weight-bold;
                }

                li:not(.hint) {
                    &.active {
                        background: var(--primary);
                    }

                    &:hover {
                        background: $secondary-background-color;
                        color: $text-color;
                    }
                }
            }
        }
    }
</style>
